import './TimeseriesTimeBottomAxisArea.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var timeBottomAxisContainer = _7a468({defaultClassName:'_19z0vdp0-3-12-1',variantClassNames:{isTouchableDevice:{true:'_19z0vdp1-3-12-1'}},defaultVariants:{},compoundVariants:[]});